export function useConfig() {
    return { 
        deploymentMode: useRuntimeConfig()?.public?.deploymentMode || 'enterprise'
    }
}